export default __webpack_public_path__ + "static/adorno2-b5a2226d5d38331db0849f565c889922.png";